import React from 'react';
import './Testimonial.css';

function Testimonial() {
  const testimonials = [
    {
      quote: "I used LeetEngineer yesterday and found it incredibly helpful! The questions were spot-on for my mechanical engineering field and really prepared me for real interviews.",
      name: "Marcus Anderson",
      role: "Junior Mechanical Engineer",
      company: "Integrated",
      initial: "MA",
      rating: 5
    },
    {
      quote: "Wow, LeetEngineer is much better than I imagined! This platform is exactly what mechanical engineers need for interview prep.",
      name: "Victoria Chen",
      role: "Mechanical Design Engineer",
      company: "SABA",
      initial: "VC",
      rating: 5
    },
    {
      quote: "LeetEngineer transformed my battery design interviews. Its focus on structural engineering and real scenarios set me up for success at Tesla.",
      name: "Jordan Mitchell",
      role: "Battery Structure Design Engineer",
      company: "Tesla",
      initial: "JM",
      rating: 5
    }
  ];

  return (
    <div className="testimonial-section">
      <h2>What Our Users Say</h2>
      <p>Hear from engineers who have transformed their interview success with our platform.</p>
      <div className="testimonial-container">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="testimonial-quote">
              "{testimonial.quote}"
            </div>
            <div className="testimonial-author">
              <div className="author-avatar">{testimonial.initial}</div>
              <div className="author-info">
                <div className="author-name">{testimonial.name}</div>
                <div className="author-role">{testimonial.role}</div>
                <div className="author-bottom">
                  <div className="author-company">{testimonial.company}</div>
                  <div className="author-rating">
                    {Array.from({ length: testimonial.rating }, (_, i) => (
                      <span key={i} className="star">★</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonial;